<template>
  <!-- 项目详情：项目信息 / 测试信息 两个页签 -->
  <div class="defaultViewStyle project-detail">
    <div v-if="project.id" class="pd-root">
      <!-- 头部信息卡 -->
      <div class="pd-header">
        <div class="pd-header-row">
          <el-page-header @back="goBack" :content="project.projectCode + ' ' + project.projectName"/>
          <div class="pd-tags">
            <el-tag size="small" :type="statusTag">{{ statusText }}</el-tag>
            <el-tag v-if="project.projectType" size="small" type="info">{{ project.projectType }}</el-tag>
            <el-tag v-if="project.priority" size="small" :type="priorityTag">{{ project.priority }}</el-tag>
          </div>
        </div>
        <div class="pd-meta">
          <span>提出人：{{ project.sourceName || '—' }}</span>
          <span>期望完成：{{ dateOnly(project.expectDate) }}</span>
          <span>任务 {{ project.taskCount || 0 }} · 批次 {{ project.sprintCount || 0 }}</span>
        </div>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="项目信息" name="info" lazy>
          <project-info :project-id="projectId" :project-label="projectLabel" :project-name="project.projectName"/>
        </el-tab-pane>
        <el-tab-pane label="测试信息" name="message" lazy>
          <test-info :project-id="projectId"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else v-loading="true" class="pd-loading"/>
  </div>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import ProjectInfo from "./ProjectInfo.vue";
import TestInfo from "./TestInfo.vue";
import projectApi from "@/api/dz-project/project/projectApi";
import {projectStatusLabel as projectStatusLabelOf, projectStatusTag as projectStatusTagOf} from "./projectStatus";

export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "ProjectDetail",
  components: {ProjectInfo, TestInfo},
  data() {
    return {
      projectId: "",
      project: {},
      activeTab: "info",
    };
  },
  computed: {
    projectLabel() {
      const code = this.project.projectCode || "";
      const name = this.project.projectName || "";
      return (code + " " + name).trim();
    },
    statusText() {
      return projectStatusLabelOf(this.project.projectStatus) || "—";
    },
    statusTag() {
      return projectStatusTagOf(this.project.projectStatus) || "info";
    },
    priorityTag() {
      return {紧急: "danger", 高: "warning", 中: "primary", 低: "info"}[this.project.priority] || "info";
    },
  },
  beforeRouteLeave(to, from, next) {
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    const id = this.route.query.id;
    if (!id) {
      return;
    }
    this.projectId = id;
    const project = await projectApi.findById(id);
    this.project = project || {};
  },
  methods: {
    goBack() {
      this.router.back();
    },
    dateOnly(v) {
      return v ? String(v).slice(0, 10) : "—";
    },
  },
};
</script>

<style lang="scss" scoped>
.project-detail {
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .pd-root {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 4px;
    //border: 1px solid var(--yq-border-color);
    padding: 12px 16px;
    box-sizing: border-box;
    .pd-header {
      border-bottom: 1px solid var(--el-border-color-lighter);
      padding-bottom: 10px;
      margin-bottom: 6px;
      .pd-header-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .pd-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 0 18px;
        margin-top: 6px;
        font-size: 13px;
        color: var(--yq-font-color-desc);
        .progress-item {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          .progress-text {
            font-weight: 600;
            color: #409eff;
          }
        }
      }
    }
    .el-tabs {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      :deep(.el-tabs__content) {
        flex: 1;
        overflow: hidden;
      }
      :deep(.el-tab-pane) {
        height: 100%;
      }
    }
  }
  .pd-loading {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
